import { createComponent } from '@carvana/merch-components';
import React from 'react';

export default createComponent<React.HTMLProps<HTMLAnchorElement>>('a', {
  className: 'text-blue-2 hover:text-blue-3'
});
